<template>
    <div class="replacement-part-finder__wrapper">
        <div class="replacement-part-finder__container">
            <div class="replacement-part-finder__bg-box">
                <div class="replacement-part-finder">
                    <div class="replacement-part-finder__head-container">
                        <div class="replacement-part-finder__head replacement-part-finder__head--left">
                            <h1>{{ $translate('OD3dprimaV2::Template.replacementPartFinderHeadline') }}</h1>
                            <p>
                                {{ $translate('OD3dprimaV2::Template.replacementPartFinderText') }}
                            </p>
                        </div>
                        <div class="replacement-part-finder__head replacement-part-finder__head--right">

                            <lazy-img
                                    :image-url="imageTablet"
                                    :image-url-tablet="imageTablet"
                                    :image-url-desktop="imageDesktop"
                                    :alt="$translate('OD3dprimaV2::Template.replacementPartFinderHeadline')"
                                    :title="$translate('OD3dprimaV2::Template.replacementPartFinderHeadline')">
                            </lazy-img>

                        </div>
                    </div>

                    <div class="replacement-part-finder__select-container">
                        <div class="replacement-part-finder__select replacement-part-finder__select--left">
                            <div class="replacement-part-finder__select-wrapper">
                                <label>{{ $translate('OD3dprimaV2::Template.replacementPartFinderSelectBrand') }}</label>
                                <select @change="selectBrand($event.target.value)">
                                    <option value="0" v-if="!facets.values.length">{{ $translate('OD3dprimaV2::Template.replacementPartFinderSelectBrandPlaceholder') }}</option>
                                    <option v-for="item in manufacturers" v-if="item.details.length > 0" :value="item.id">{{ item.details[0].name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="replacement-part-finder__select replacement-part-finder__select--right" :class="{'replacement-part-finder__select--inactive' : !facets.values.length}">
                            <div class="replacement-part-finder__select-wrapper">
                                <label>{{ $translate('OD3dprimaV2::Template.replacementPartFinderSelectModel') }}</label>
                                <select @change="selectModel($event.target.value)" ref="modelselect">
                                    <option value="0" v-if="!itemList.length">{{ $translate('OD3dprimaV2::Template.replacementPartFinderSelectModelPlaceholder') }}</option>
                                    <option v-for="item in facets.values" :value="item.id">{{ item.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="replacement-part-finder__itemlist" v-if="itemList.length">
                <div class="replacement-part-finder__filter">
                    <a href="#" @click.prevent="selectFacet(0)" :class="{'active' : activeFacet === 0 }">{{ $translate('OD3dprimaV2::Template.replacementPartFinderShowAll') }}</a>
                    <a href="#" v-for="facet in facetsForFilter.values" :class="{'active' : activeFacet === facetPropMapping[facet.id] }" @click.prevent="selectFacet(facetPropMapping[facet.id])">
                        {{ facet.name }}
                    </a>
                </div>
                <div class="product-list row" id="js--product-list">
                    <div class="product-list__col col-12 col-md-4 col-xl-2-4" v-for="item in itemList" v-if="isInFacetSelection(facetPropertyId(item.id))">
                        <category-item :item-data="item.data" :key="item.id">
                            <div v-for="container in item.layoutContainer"
                                 :slot="container.id"
                                 v-html="container.content">
                            </div>
                        </category-item>
                    </div>
                    <div class="product-list__col product-list__col--no-items col-12">{{ $translate('OD3dprimaV2::Template.replacementPartFinderNoItems') }}</div>
                </div>

                <div class="mt-4 mb-4 text-center" v-if="currentPage < maxPages">
                    <button class="btn btn-primary trigger-load-more">
                        <template>
                            {{ $translate('OD3dprimaV2::Template.loadMoreLoading') }}
                        </template>

                    </button>
                </div>
            </div>
        </div>
        <div  class=" is-loading"></div>
        <div v-if="loadingFromSelects" class="replacement-part-finder__loading-overlay d-none d-lg-block is-loading">
            <i class="fa fa-circle-o-notch fa-spin mobile-icon-right"></i>
        </div>
    </div>
</template>

<script>
    import ApiService from 'ceres/app/services/ApiService';

    export default {
        props: {
            manufacturers: Array,
            imageDesktop:{
                type: String,
                default: "https://via.placeholder.com/700x325"
            },
            imageTablet:{
                type: String,
                default: "https://via.placeholder.com/700x325"
            }
        },
        data() {
            return {
                facets: [],
                facetsForFilter: [],
                itemList: [],
                maxItems: 0,
                maxPages: 0,
                loading: false,
                loadingFromSelects: false,
                currentPage: 1,
                selectedManufacturer: 0,
                selectedModel: 0,
                activeFacet: 0,
                facetPropMapping: {
                    333: 284, // Elektronic
                    334: 285, // Fan
                    335: 286, // Filter
                    336: 287, // Hotend
                    337: 288, // Maintenance Kit
                    338: 289, // Mechanical
                    339: 290, // Motor
                    340: 291, // Resin Tank
                    341: 292, // Print Surface
                    342: 293, // Stepper Driver
                    344: 295 // Nozzle
                },
                layoutContainer: [
                    {
                        name : 'Ceres::CategoryItem.BeforePrices',
                        id   : 'before-prices'
                    },
                    {
                        name : 'Ceres::CategoryItem.AfterPrices',
                        id   : 'after-prices'
                    },
                    {
                        name : 'OD3dprimaV2::CategoryItem.Ratings',
                        id   : 'ratings'
                    },
                ]
            };
        },
        computed: {

        },
        created() {

        },
        mounted()
        {
            this.$nextTick(() =>
            {
                let that = this;
                $(window).scroll(function(){
                    that.triggerLoadMoreCheck();
                });
            });
        },
        methods: {
            selectBrand(value){

                this.selectedManufacturer = value;
                this.loadingFromSelects = true;
                this.facets = [];

                let fallBackFacets = null;

                ApiService.get(
                    window.location.origin + '/rest/OD3dprimaV2/category?items=100&categoryId=' + value +
                    '&page=1&layoutContainer=' + encodeURIComponent(JSON.stringify(this.layoutContainer))).done(response => {
                        for(let key in response.facets){
                            if(response.facets.hasOwnProperty(key)){
                                if(response.facets[key].cssClass == value){
                                    this.facets = response.facets[key];
                                    break;
                                }
                                if(response.facets[key].id === 11){
                                    fallBackFacets = response.facets[key];
                                }
                            }
                        }

                        if(this.facets.length === 0){
                            this.facets = fallBackFacets;
                        }

                        this.loadingFromSelects = false;

                        this.selectModel(0);
                })
            },

            selectModel(value){

                this.selectedModel = value;
                this.currentPage = 1;
                this.maxItems = 0;
                this.maxPages = 0;
                this.loadingFromSelects = true;

                if(value === 0){
                    this.$refs.modelselect.value = 0;
                    this.itemList = [];
                    this.loadingFromSelects = false;
                    return;
                }

                ApiService.get(
                    window.location.origin + '/rest/OD3dprimaV2/category?items=20&categoryId=' + this.selectedManufacturer +
                    '&page=1&facets='+value+"&layoutContainer=" + encodeURIComponent(JSON.stringify(this.layoutContainer))).done(response => {
                    this.itemList = response.itemList.documents;
                    this.maxItems = response.itemList.total;
                    this.maxPages = Math.ceil(response.itemList.total / 20);
                    this.loadingFromSelects = false;

                    for(let key in response.facets){
                        if(response.facets.hasOwnProperty(key)){
                            if(response.facets[key].id === 28){
                                this.facetsForFilter = response.facets[key];
                            }
                        }
                    }
                })
            },

            selectFacet(id){
                this.activeFacet = id;

                this.$nextTick(() =>
                    {
                        this.triggerLoadMoreCheck();
                    });
            },

            facetPropertyId(itemId){
                let ids = '';

                for(let key in this.itemList){
                    if(this.itemList.hasOwnProperty(key)){
                        if(this.itemList[key].id === itemId){
                            for(let innerKey in this.itemList[key].data.properties){
                                if(this.itemList[key].data.properties.hasOwnProperty(innerKey)){
                                    if(this.itemList[key].data.properties.length === parseInt(innerKey)+1){
                                        ids += this.itemList[key].data.properties[innerKey].propertyId
                                    }else{
                                        ids += this.itemList[key].data.properties[innerKey].propertyId + ',';
                                    }
                                }
                            }
                            break;
                        }
                    }
                }

                return ids;
            },

            isInFacetSelection(ids){
                if(this.activeFacet === 0){
                    return true;
                }

                if(ids.indexOf(this.activeFacet) > -1){
                    return true;
                }
                return false;
            },

            triggerLoadMoreCheck(){
                let el = document.querySelector('.trigger-load-more');
                if(el !== null){
                    var top = el.offsetTop;
                    var left = el.offsetLeft;
                    var width = el.offsetWidth;
                    var height = el.offsetHeight;

                    while(el.offsetParent) {
                        el = el.offsetParent;
                        top += el.offsetTop;
                        left += el.offsetLeft;
                    }

                    let loadMore =
                        top < (window.pageYOffset + window.innerHeight) &&
                        left < (window.pageXOffset + window.innerWidth) &&
                        (top + height) > window.pageYOffset &&
                        (left + width) > window.pageXOffset;

                    if(loadMore && !this.loading){
                        this.loadItems();
                    }
                }
            },

            loadItems(){
                this.currentPage = this.currentPage+1;
                this.loading = true;

                ApiService.get(
                    window.location.origin + '/rest/OD3dprimaV2/category?items=20&categoryId=' + this.selectedManufacturer +
                    '&page='+this.currentPage+'&facets='+this.selectedModel+'&layoutContainer=' + encodeURIComponent(JSON.stringify(this.layoutContainer))).done(response => {
                    this.itemList = this.itemList.concat(response.itemList.documents);
                    this.loading = false;
                })
            }
        }
    }
</script>
